import AudioFile from "@mui/icons-material/AudioFile";
import Code from "@mui/icons-material/Code";
import Folder from "@mui/icons-material/Folder";
import FolderZipOutlined from "@mui/icons-material/FolderZipOutlined";
import Image from "@mui/icons-material/Image";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import VideoFile from "@mui/icons-material/VideoFile";
import Description from "@mui/icons-material/Description";
import TableChart from "@mui/icons-material/TableChart";

interface MimeIconProps {
  contentType: string | undefined;
}

export default function MimeIcon({ contentType }: MimeIconProps) {
  const iconSize = { xs: 56, sm: 64 };

  const fallbackIcon = (
    <InsertDriveFileOutlined
      sx={{
        fontSize: iconSize,
        color: '#5f6368',
      }}
    />
  );

  if (typeof contentType !== "string") return fallbackIcon;

  // Images - blue
  if (contentType.startsWith("image/")) {
    return (
      <Image
        sx={{
          fontSize: iconSize,
          color: '#ea4335',
        }}
      />
    );
  }

  // Audio - red
  if (contentType.startsWith("audio/")) {
    return (
      <AudioFile
        sx={{
          fontSize: iconSize,
          color: '#ff6d00',
        }}
      />
    );
  }

  // Video - red
  if (contentType.startsWith("video/")) {
    return (
      <VideoFile
        sx={{
          fontSize: iconSize,
          color: '#ea4335',
        }}
      />
    );
  }

  // PDF - red
  if (contentType === "application/pdf") {
    return (
      <PictureAsPdf
        sx={{
          fontSize: iconSize,
          color: '#ea4335',
        }}
      />
    );
  }

  // Archives - yellow/orange
  if (["application/zip", "application/gzip", "application/x-rar-compressed", "application/x-7z-compressed"].includes(contentType)) {
    return (
      <FolderZipOutlined
        sx={{
          fontSize: iconSize,
          color: '#f9ab00',
        }}
      />
    );
  }

  // Spreadsheets - green
  if (contentType.includes("spreadsheet") || contentType.includes("excel") || contentType === "text/csv") {
    return (
      <TableChart
        sx={{
          fontSize: iconSize,
          color: '#0f9d58',
        }}
      />
    );
  }

  // Documents - blue
  if (contentType.includes("document") || contentType.includes("word") || contentType.includes("text")) {
    return (
      <Description
        sx={{
          fontSize: iconSize,
          color: '#4285f4',
        }}
      />
    );
  }

  // Code - grey
  if (contentType.startsWith("text/") || contentType.includes("javascript") || contentType.includes("json")) {
    return (
      <Code
        sx={{
          fontSize: iconSize,
          color: '#5f6368',
        }}
      />
    );
  }

  // Directory
  if (contentType === "application/x-directory") {
    return (
      <Folder
        sx={{
          fontSize: iconSize,
          color: '#5f6368',
        }}
      />
    );
  }

  return fallbackIcon;
}
